<template>
  <v-dialog v-model="dialog" max-width="560" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Pendaftaran</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text my-5">
        <h1 class="text-center mb-10" style="font-size: 24px">
          PAKTA INTEGRITAS <br />PESERTA SELEKSI SEKOLAH PENGGERAK
        </h1>
        <p class="black--text">
          Anda termasuk dalam calon peserta Program Sekolah Penggerak
          <b v-if="Object.keys(registrasi).length">
            Angkatan {{ registrasi.peserta || registrasi.pelatih_ahli || registrasi.instruktur }}.</b
          >
        </p>
        <h4 class="mb-2">Peran Anda</h4>
        <v-alert
          text
          outlined
          :color="
            !(registrasi.peserta || registrasi.tutup_peserta) ? '#F3F3F3' : form.peran === 'kasek' ? 'info' : 'grey'
          "
        >
          <v-radio-group v-model="form.peran" hide-details class="pa-0 ma-0">
            <v-radio value="kasek" :disabled="!!$getDeepObj(registrasi, 'tutup_peserta')">
              <template v-slot:label>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="mb-1 black--text text-bold">
                      Peserta - Program Sekolah Penggerak
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <p class="body-2 grey--text ma-0">
                      merupakan peran yang memiliki akses untuk mengikuti kegiatan yang telah disusun pada Program
                      Sekolah Penggerak
                    </p>
                  </v-col>
                  <v-col cols="12" v-if="!!$getDeepObj(registrasi, 'tutup_peserta')">
                    <br />
                    <div class="blue--text caption">
                      <v-icon left small color="blue">mdi-information</v-icon>
                      {{ $getDeepObj(registrasi, 'tutup_peserta') }}
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-radio>
          </v-radio-group>
        </v-alert>
        <v-alert
          text
          outlined
          :color="
            !(registrasi.instruktur || registrasi.pelatih_ahli) ? '#F3F3F3' : form.peran === 'pa' ? 'info' : 'grey'
          "
        >
          <v-radio-group v-model="form.peran" hide-details class="pa-0 ma-0">
            <v-radio value="pa" :disabled="!!$getDeepObj(registrasi, 'tutup_pelatih_ahli')">
              <template v-slot:label>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="mb-1 black--text text-bold">
                      Fasilitator - Program Sekolah penggerak
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <p class="body-2 grey--text ma-0">
                      merupakan peran yang memiliki akses untuk mengikuti kegiatan yang telah disusun pada Program
                      Sekolah Penggerak.
                    </p>
                  </v-col>
                  <v-col cols="12" v-if="!!$getDeepObj(registrasi, 'tutup_pelatih_ahli')">
                    <br />
                    <div class="blue--text caption">
                      <v-icon left small color="blue">mdi-information</v-icon>
                      {{ $getDeepObj(registrasi, 'tutup_pelatih_ahli') }}
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-radio>
          </v-radio-group>
        </v-alert>
        <v-form v-show="form.peran === 'pa'" ref="form" v-model="valid" lazy-validation>
          <v-container class="pa-0 py-2">
            <v-row>
              <v-col cols="12">
                <v-subheader class="px-0 body-2 secondary--text" style="height: 24px">
                  Unsur Fasilitator
                </v-subheader>
                <v-select
                  :items="master"
                  item-text="keterangan"
                  item-value="k_unsur_psp"
                  v-model="form.k_unsur_psp"
                  :rules="[(v) => !!v || 'Unsur Wajib dipilih']"
                  label="Unsur"
                  single-line
                  dense
                  outlined
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-alert v-if="unsurEror && $isObject(unsurEror)" text type="error">
          <p class="body-1 text-bold mb-0">
            Mohon maaf, {{ unsurEror && unsurEror.tutup ? 'peran' : 'unsur' }} yang Anda pilih belum bisa mengikuti
            seleksi program Sekolah Penggerak karena kemungkinan berikut:
          </p>
          <ul class="pl-0 black--text body-2">
            <template v-if="unsurEror && unsurEror.tutup">
              <li>{{ unsurEror.tutup }}.<br /> </li>
            </template>
            <template v-if="unsurEror.kasek_cadangan === true">
              <span>
                Saat ini Bapak/Ibu merupakan Kepala Sekolah yang lulus dengan status cadangan pada Program Sekolah
                Penggerak Angkatan 2. Jadwal pembukaan pendaftaran/registrasi ulang masih belum dibuka dan akan segera
                diinformasikan melalui e-mail dan SIMPKB.
              </span>
            </template>
            <template v-if="unsurEror.kasek === false">
              <li>
                Anda terdeteksi bukan sebagai Kepala Sekolah berdasarkan data Dapodik. <br />
                Jika Anda sekarang bertugas sebagai Kepala Sekolah Definitif di sekolah dalam daerah sasaran namun
                menerima informasi ini, silahkan melakukan pengkinian data Dapodik pada bagian JENIS PTK DAN TUGAS
                TAMBAHAN HARUS TERISI KEPALA SEKOLAH . Pengkinian data Dapodik maksimal 5 hari sebelum batas akhir
                pendaftaran.
              </li>
            </template>
            <template v-if="unsurEror.dapodik === false">
              <li> Data Anda belum tersambung dengan data Dapodik.<br /> </li>
            </template>
            <template v-if="unsurEror.kualifikasi === false">
              <li>
                Pendidikan terakhir Anda tidak memenuhi persyaratan minimal. Jika pendidikan terakhir Anda tidak sesuai
                mohon perbaharui data Anda di Dapodik.
              </li>
            </template>
            <template v-if="unsurEror.unsur === false">
              <li>
                Unsur yang Anda pilih tidak relevan dengan data Dapodik Anda.
              </li>
            </template>
            <template v-if="unsurEror.usia === false">
              <li>
                Usia Anda tidak memenuhi persyaratan
              </li>
            </template>
            <template v-if="unsurEror.sasaran === false">
              <li>
                Wilayah Tugas diluar Sasaran PSP.
              </li>
            </template>
          </ul>
        </v-alert>
        <v-checkbox class="mt-2 mb-3" v-model="isChecked">
          <template v-slot:label>
            <div class="body-2 black--text">
              Jika saya lolos semua tahap seleksi, saya bersedia mengikuti seluruh kegiatan sebagai peserta program
              Sekolah Penggerak
            </div>
          </template>
        </v-checkbox>
        <div class="mb-5">
          <v-btn block color="secondary" :disabled="!isChecked" @click="save">
            Daftar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopupPendaftaran',
  props: {
    tipe: {
      type: String,
      default: 'kasek',
    },
    master: {
      type: Array,
      default: () => [],
    },
    unsurEror: {
      type: Object,
      default: () => {},
    },
    registrasi: {
      default: () => {},
    },
    preferensi: {
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      dialog: false,
      isChecked: false,
      form: {},
    };
  },
  methods: {
    open() {
      this.form = {};
      this.isChecked = false;
      this.dialog = true;

      if (Object.keys(this.registrasi).length === 1) {
        this.form = { peran: this.registrasi.peserta ? 'kasek' : 'pa' };
      }
    },

    close() {
      this.dialog = false;
    },

    save() {
      if (!this.$isObject(this.form)) {
        this.$error('Harap Pilih Jenis Pendaftaran');
        return;
      }
      this.$emit('daftar', this.form);
    },

    resetUnsurError() {
      this.$emit('resetUnsurError', this.form);
    },
  },
  watch: {
    'form.peran': 'resetUnsurError',
  },
};
</script>
